import {Button, Loader, Modal} from '@logistics-frontend/blocks'
import React from 'react'

import * as classes from './PaymentCardAdd.classes'
import {TrustFrame} from './TrustFrame'
import {useTrustModal} from './TrustModal.hooks'
import {Props} from './TrustModal.types'

export function TrustModal(props: Props): React.ReactElement<Props> {
  const {onClose, onSuccess} = props
  const {isPending, bindingUrl, error, translates, updateHandler} = useTrustModal(props)

  function renderChildren() {
    if (isPending) {
      return <Loader size="m" />
    }

    if (bindingUrl) {
      return <TrustFrame bindingUrl={bindingUrl} onClose={onClose} onSuccess={onSuccess} />
    }

    if (error) {
      return (
        <Button onPress={updateHandler} variant="action">
          {translates.repeat}
        </Button>
      )
    }

    return '🤷'
  }

  return (
    <Modal onClose={onClose} opened>
      <Modal.Header text={translates.subtitle} title={translates.title} />
      <Modal.Body className={classes.modalBody}>{renderChildren()}</Modal.Body>
    </Modal>
  )
}
